module.exports = {
  INIT: 'init',
  ON_WAY: 'on-way',
  AT_PICKUP: 'at-pickup',
  ON_BOARD: 'on-board',
  VALIDATED: 'validated',
  CANCELLED: 'cancelled',
};
